import React from "react";

const PageLineBreak = ({ }) => {
  return <div css={{ ...styles.lineBreak }} />;
};

export default PageLineBreak;

const styles = {
  lineBreak: {
    height: '45px'
  },
};
